import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import { keepPreviousData, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { App } from './App'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity, // vypnutí refetch při procházení. Znovu se to fetchne při f5
            gcTime: Infinity,
            refetchOnWindowFocus: false,
            placeholderData: keepPreviousData,
            retry: false,
        },
    },
})

ReactDOM.createRoot(document.querySelector('#r-a-search-bar')!, { identifierPrefix: 'r-a-search-bar' }).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <App />
            <ReactQueryDevtools />
        </QueryClientProvider>
    </StrictMode>,
)
